module.exports = __webpack_public_path__ + "media/images/birthday/birthday-template-kz-ea523efba613ea70fd2689087db1d993.png";